import { Column } from 'primereact/column'
import { DataTable } from 'primereact/datatable'
import { InputText } from 'primereact/inputtext'
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../reducers';
import { LoginService } from '../services/LoginService';
import useEffectOnce from '../hooks/useEffectOnce';
import { fetchActivitiesData } from '../reduxactions/ConsultancyActions/ActivitiesActions';
import { useDispatch } from 'react-redux';
import { Image } from 'primereact/image';

var imageuser = require('../assets/img/images.png');

export const ConOffActivities = () => {
    const uid = window.sessionStorage.getItem('uid');
    //const photo = window.sessionStorage.getItem('photo');

    const [globalFilter, setGlobalFilter] = useState('');
    const [photo, setPhoto] = useState('');
    const [profile, setProfile] = useState<[]>([]);
    const dispatch = useDispatch();
    const data = useSelector((state: RootState) => state.activities.data);
    const [addeddate, setAddeddate] = useState<[]>([]);
    const [userImage, setUserImage] = useState('');
    const [activity, setActivity] = useState('');

    useEffectOnce(() => {
        const fetchDataAsync = async () => {
            try {
                await dispatch(fetchActivitiesData() as any);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };
        fetchDataAsync();
    }, [dispatch]);
    const getProfile = async () => {
        try {
            const payload = { uid: uid };
            const apiname = '/ws_an_get_consultancy_officer_profile.php';
            const data = await LoginService.getData(apiname, payload);
            setPhoto(data[0].photo);
            setAddeddate(data[0].addeddate);
            setActivity(data[0].activity);
            setProfile(data);
        } catch (error) {

        }


    };
    useEffectOnce(() => {
        getProfile();
    }, []);

    const renderImageWithDetails = (rowData: any) => {
        const userImage = photo || imageuser;;


        return (
            <div>
                <div
                    style={{
                        display: 'grid',
                        gridTemplateColumns: '55px auto',
                        alignItems: 'center',
                        columnGap: '10px',
                    }}
                >

                    <img
                        className="profile-user-img img-responsive img-circle"
                        src={userImage}
                        alt="User Image"
                        style={{
                            width: '55px',
                            height: '50px',
                            borderRadius: '50%',
                            border: '3px solid #adb5bd',
                            padding: '2px',
                        }}
                    />
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'space-between',
                            textAlign: 'left',
                            gap: '4px',
                        }}
                    >
                        <span style={{ fontWeight: 'bold' }}>{rowData.addeddate}</span>
                        <span>{rowData.activity}</span>
                    </div>
                </div>
            </div>
        )
    };
    //for help
    const [openHelp, setHelp] = useState(false);
    const url1 = window.sessionStorage.getItem("apiRoot");
    const IUrl = `${url1}/help/conactivities.php`;
    const helpImg = `${url1}/help/help3.png`;
    const openWindow = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, targetUrl: string): void => {
        event.preventDefault();
        const newWindowReference = window.open(
            targetUrl,
            'newwindow',
            'width=1000,height=1000,noopener,noreferrer'
        );

        if (newWindowReference) {
            newWindowReference.opener = null;
        }
    };
    return (
        <div className="main-content">

            <div className="content-wrapper">
                <section className="content-header">
                    <div className="container-fluid">
                        <div className="grid mb-2">
                            <div className="col-9">
                                <h2> Activities</h2>
                            </div>
                            <div className="col-3">
                                <a
                                    title="help"
                                    onClick={(e) => openWindow(e, IUrl)}
                                    style={{

                                        color: "blue",
                                        fontSize: 15, cursor: "pointer"
                                    }}
                                >Help for this Page &nbsp;
                                    <i style={{ marginTop: 40, backgroundColor: "orange", color: "white" }} className="pi pi-question-circle"></i>

                                </a>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="content">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card-header p-2"></div>
                            <div className="box box-primary">
                                <div className="card"></div>
                                <div className="card flex flex-wrap justify-content">
                                    <span className="p-input-icon-left">
                                        <i className="pi pi-search" />
                                        <InputText value={globalFilter} onChange={(e) => setGlobalFilter(e.target.value)} placeholder="Global Search" />
                                    </span>
                                </div>
                                <div className="card">
                                    <DataTable value={data} tableStyle={{ minWidth: '50rem' }} globalFilter={globalFilter} >


                                        <Column header="Reports" body={renderImageWithDetails} />

                                    </DataTable>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div >
        </div >
    )
}
